export default __webpack_public_path__ + "static/media/science.af77f10c.png";